import type { AgentRunStatus } from '@/types/appRouter';

type SessionStatusDotProps = {
    status: AgentRunStatus | string | null;
};

const STATUS_STYLES: Partial<Record<AgentRunStatus, string>> = {
    running: 'bg-green-500 animate-pulse',
    waiting_confirmation: 'bg-yellow-500',
    queued: 'bg-blue-500',
    stalled: 'bg-orange-500',
    failed: 'bg-red-500'
};

const STATUS_LABELS: Partial<Record<AgentRunStatus, string>> = {
    running: 'Running',
    waiting_confirmation: 'Waiting for confirmation',
    queued: 'Queued',
    stalled: 'Stalled',
    failed: 'Failed'
};

export function SessionStatusDot({ status }: SessionStatusDotProps) {
    if (!status) return null;

    const style = STATUS_STYLES[status as AgentRunStatus];
    if (!style) return null;

    return (
        <span className={`inline-block h-2 w-2 rounded-full shrink-0 ${style}`} title={STATUS_LABELS[status as AgentRunStatus] ?? status} />
    );
}
